/* eslint-disable max-lines-per-function */
import React from "react";
import { Formik, Form } from "formik";
import * as yup from "yup";
import { Button, Grid } from "@mui/material";
import { DialogActions, DialogContent } from "components/haven-design/modal/dialog";
import { Modal } from "components/haven-design";
import { InputWithErrorLabel as Input } from "components/haven-design/form/inputs";
import { ListBuildingUnits_buildingUnits as BuildingUnitType } from "types/gql-types";
import UnitFormSharedFields, { BuildingUnitSharedType, sharedFieldsValidations } from "./unit-form-shared-fields";
type UnitFormValues = Omit<BuildingUnitType, "id" | "name" | "__typename" | "buildingId"> & {
  numberOfUnits: number;
  unitNames: string[];
}

const initialValues: UnitFormValues = {
  numberOfUnits: 1,
  unitNames: [],
  bedrooms: "",
  bathrooms: 0,
  occupancyMin: 0,
  occupancyMax: 0,
  rentType: "fixed",
  rentValue: 0,
  sqft: 0,
  floor: 0,
  occupied: "Vacant",
  isReferral: false,
  referralOrg: "",
  accessibility: [],
  fundingSource: [],
  preference: [],
  incomeDesignation: "none",
};

const validationSchema = yup.object().shape({
  numberOfUnits: yup.number()
    .required("Number of units is required")
    .min(1, "At least 1 unit is required"),
  unitNames: yup.array().of(yup
    .string()
    .matches(
      /^[A-Za-z0-9\s\-_/]*$/,
      "Invalid characters. Only alphanumeric characters, spaces, and -_/ are allowed.",
    )
    .required("Unit name is required")),
  ...sharedFieldsValidations,
});

type Props = {
  handleBatchAddUnit: (names: string[], sharedValues: BuildingUnitSharedType) => void
  open: boolean,
  closeModal: () => void,
}
const BatchUnitAddForm: React.FC<Props> = ({ handleBatchAddUnit, open, closeModal }) => (
  <Modal
    onRequestClose={closeModal}
    isOpen={open}
    title="Batch Add Units"
    fullScreen
  >
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      onSubmit={({ unitNames, numberOfUnits, ...sharedValues }) => {
        handleBatchAddUnit(unitNames, sharedValues);
        closeModal();
      }}
    >
      {({ values, isSubmitting }) => (<>
        <DialogContent>
          <Form id="batch-add-units">
            <Grid container spacing={2}>
              <Grid size={{ xs: 12 }}>
                <Input
                  id="numberOfUnits"
                  margin="none"
                  name="numberOfUnits"
                  label="Number of units"
                  type="number"
                  slotProps={{ htmlInput: { min: "1" } }}
                />
              </Grid>

              {[...Array(values.numberOfUnits).keys()].map((i) => (
                <Grid size={{ xs: 12 }} key={`unit-name-${i}`}>
                  <Input
                    margin="none"
                    label={`Unit #${i + 1} Name`}
                    id={`unitNames.${i}`}
                    name={`unitNames.${i}`} required />
                </Grid>
              ))}
              <UnitFormSharedFields/>
            </Grid>
          </Form>
        </DialogContent>
        <DialogActions>
          <Button variant="outlined" color="secondary" onClick={closeModal}>Cancel</Button>
          <Button
            form="batch-add-units"
            variant="contained"
            color="primary"
            type="submit"
            disabled={isSubmitting}
          >
            Add Units
          </Button>

        </DialogActions>
      </>
      )}
    </Formik>
  </Modal>
);

export default BatchUnitAddForm;
